import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ScrollContainer from "react-indiana-drag-scroll";
import { Link } from "react-router-dom";
import ReactPlayer from 'react-player'
import { getAllCourse } from "../redux/actions/PlanAction";
import { useSnackbar } from "react-simple-snackbar";
import elearn from "../assets/elearn.png"

const Courses = () => {
    const dispatch = useDispatch();
    const [allCourses, setAllCourses] = useState();

    const [openSnackbar, closeSnackbar] = useSnackbar();
    //Get Courses
    useEffect(() => {

        const onSuccess = (res) => {
            console.log(res)
            setAllCourses(res.allCourses)
        };
        const onError = () => {
            openSnackbar("Something went wrong !!");
        };
        dispatch(getAllCourse(onSuccess, onError));
    }, [])

    console.log(allCourses)
    return (
        <div className="courses">
            <div className="row">
                <div className="col-12">
                    <div className="course-container">
                        {/* <div className="video">
                            Courses
                        </div> */}
                        <div className="top-card">
                            <div className="clapingo">Clapingo</div>
                            <div className="course-title">
                                Courses

                            </div>
                            <div className="text-center">
                                <img src={elearn} width="40%" height="40%" alt="course img" />
                            </div>
                        </div>
                        <ScrollContainer
                            horizontal={true}
                        // className="wrapper mt-4 mb-4 pl-5 pr-5"
                        >
                            <div className="row mx-auto">
                                {allCourses?.map((data, i) => (
                                    <div className="course-card">
                                        <div className="thumb">
                                            <Link to={`/course?courseId=${data._id}`}>
                                                <img src={data.thumbnail} width="348px" height="180px" style={{ borderRadius: "9px 9px 0px 0px" }} alt="thumbnail" />
                                            </Link>
                                        </div>
                                        <div className="d-flex ml-3 mr-3 mt-4">

                                            <Link to={`/course?courseId=${data._id}`}>
                                                <div className="course-title">{data.courseName}  </div></Link>

                                            <div className="course-title ml-3">


                                            </div>
                                        </div>
                                        <div className="price ml-3 mr-3 mt-4">
                                            {
                                                data.coursePrice === 0 ? "Free" :
                                                    `Price: ₹${data.coursePrice}`
                                            }
                                        </div>
                                        {/* <div className="duration mt-3 ml-3 mb-3">
                                            12 lectures|2 hours
                                        </div> */}
                                        <div className="foot">
                                            <div className="d-flex">
                                                <div>
                                                    <img src={data.teacherImage} height="40px" width="40px" style={{ borderRadius: "50%" }} alt="teacher image" />
                                                </div>
                                                <div className=" ml-2">
                                                    <div className="teacher-name ">{data.teacherName}</div>
                                                    <div className="teacher-desc">{data.teacherDesc.length > 100 ? data.teacherDesc.slice(0, 40).concat(' ...') : data.teacherDesc}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))

                                }

                            </div>
                        </ScrollContainer >
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Courses;